module.exports = __webpack_public_path__ + "static/img/rocket_block.ecaf0ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/rocket_block.png
// module id = xnxh
// module chunks = 1